module.exports = __webpack_public_path__ + "static/media/collection-feather-getting.2dc7cd51.png";